import usePrimitiveData from "src/modules/pe-landing-module/hooks/usePrimitiveData"
import { IPrimitiveProps } from "../section/Primitive"
import { IScreenPosition } from "src/modules/pe-landing-module/data/interfaces"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"

/* Protopia Ecosystem component */ 
const Rectangle = ( props: IPrimitiveProps): JSX.Element => {
    const primitive= usePrimitiveData(props.primitive)
    const {position} = usePosition(primitive)
    return <div className={`primitive-${primitive.id}`} style={position.style || primitive.style}>
        <svg 
            width={ `${position.width || 100}` }
            height={ `${position.height || 100}` }
            x={0}
            y={0}
            xmlns="http://www.w3.org/2000/svg"
            className={ `${primitive.className} landing-primitive-svg` }
        >
            <rect 
                width={ `${position.width || 100}` }
                height={ `${position.height || 100}` }
                x="0" 
                y="0"
                rx="0" 
                ry="0" 
                fill={ primitive.fill }  
                stroke={ primitive.stroke } 
                strokeWidth={ primitive.strokeWidth } 
                strokeDasharray={ primitive.strokeDasharray }
                strokeDashoffset={ primitive.strokeDashoffset }
            />
        </svg>
    </div>
}
export default Rectangle